import React, {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";

const ConfirmContext = createContext(null);

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error("useConfirm must be used within a ConfirmProvider");
  }
  return ctx.confirm;
};

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    title: "",
    message: "",
    confirmLabel: "Remove",
    cancelLabel: "Cancel",
  });
  const resolverRef = useRef(null);

  const close = useCallback((result) => {
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
    setState((prev) => ({ ...prev, open: false }));
  }, []);

  const confirm = useCallback(
    (opts) =>
      new Promise((resolve) => {
        resolverRef.current = resolve;
        setState({
          open: true,
          title: opts?.title || "Are you sure?",
          message: opts?.message || "",
          confirmLabel: opts?.confirmLabel || "Confirm",
          cancelLabel: opts?.cancelLabel || "Cancel",
        });
      }),
    [],
  );

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <ConfirmDeleteModal
        isOpen={state.open}
        title={state.title}
        message={state.message}
        confirmLabel={state.confirmLabel}
        cancelLabel={state.cancelLabel}
        onClose={() => close(false)}
        onConfirm={() => close(true)}
      />
    </ConfirmContext.Provider>
  );
};

export default ConfirmProvider;
